import { render, staticRenderFns } from "./AdminConfiguration.vue?vue&type=template&id=a2037cc6&scoped=true&"
import script from "./AdminConfiguration.vue?vue&type=script&lang=js&"
export * from "./AdminConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./AdminConfiguration.vue?vue&type=style&index=0&id=a2037cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2037cc6",
  null
  
)

export default component.exports